import VueGtag from 'vue-gtag'
import { type App } from 'vue'

export const toGaIdSetting = (
  gaIdsRaw: string | undefined
): {
  mainId: string;
  includes: { id: string }[];
  enabled: boolean;
} => {
  const gaIds = (gaIdsRaw || '')
    .split(',')
    .map(id => id.trim())
    .filter(id => 0 < id.length)

  const [mainId = "", ...restIds] = gaIds
  const includes = restIds.map(id => ({ id }))
  const enabled = 0 < gaIds.length

  return { mainId, includes, enabled }
}

export const getCookieParams = (noSecureCookieEnv: string | undefined): Record<string, string> => {
  const secureCookie = (noSecureCookieEnv !== 'true')
  return secureCookie ? { cookie_flags: 'secure' } : {}
}

export const initVueGtag = (app: App<Element>) => {
  const gaIdsRaw = import.meta.env.VITE_APP_GA_IDS
  const { mainId, includes, enabled } = toGaIdSetting(gaIdsRaw)

  const noSecureCookieEnv = import.meta.env.VITE_APP_NO_SECURE_COOKIE
  const params = getCookieParams(noSecureCookieEnv)

  app.use(VueGtag, {
    config: {
      id: mainId,
      params,
    },
    includes,
    enabled,
  })
}
